import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, input, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import type { IAgencyInfo, Ticket } from "@kiraah-shared/common";
import { Address } from "@kiraah-shared/common";
import { TranslateModule } from "@ngx-translate/core";
import type { MobileTicketWizardComponent } from "../../mobile-ticket-wizard-page.component";

@Component({
  selector: "mobile-ticket-delivery-address-step",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: "./mobile-ticket-delivery-address-step.component.html",
  styleUrl: "./mobile-ticket-delivery-address-step.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTicketDeliveryAddressStepComponent {
  readonly wizard = input.required<MobileTicketWizardComponent>();
  readonly ticket = input.required<Ticket>();

  private readonly agencyDropdownRoot = viewChild<ElementRef<HTMLElement>>("agencyDropdownRoot");

  /** Liste déroulante sous le champ (comme `ngbDropdown` web), pas un bottom-sheet. */
  protected readonly agencyPickerOpen = signal(false);

  protected toggleAgencyDropdown(): void {
    this.agencyPickerOpen.update((isOpen) => !isOpen);
  }

  protected closeAgencyPicker(): void {
    this.agencyPickerOpen.set(false);
  }

  protected selectAgencyDeliveryMode(): void {
    const wizard = this.wizard();
    wizard.setDeliveryMode(wizard.DeliveryMode.SPECIFIED_AGENCY);
  }

  @HostListener("document:click", ["$event"])
  protected onDocumentClick(event: MouseEvent): void {
    if (!this.agencyPickerOpen()) {
      return;
    }
    const root = this.agencyDropdownRoot()?.nativeElement;
    const target = event.target;
    if (root && target instanceof Node && !root.contains(target)) {
      this.closeAgencyPicker();
    }
  }

  protected pickAgencyAndClose(agency: IAgencyInfo): void {
    this.wizard().pickDeliveryAgency(agency);
    this.agencyPickerOpen.set(false);
  }

  /** Même convention que le web (`ngx-address-detail`) : `assets/flags/{CountryCode}.png`. */
  protected deliveryCountryFlagSrc(countryCode: string | undefined | null): string {
    const raw = String(countryCode ?? "").trim().toUpperCase();
    const code = !raw || raw === "0" ? Address.DEFAULT_COUNTRY : raw;
    return `assets/flags/${code}.png`;
  }

  protected deliveryAgencyTrack(index: number, agency: IAgencyInfo): string {
    return this.wizard().deliveryAgencyTrack(index, agency);
  }
}
